export default __webpack_public_path__ + "static/media/personnalisationIcon.3812cee3.svg";